import * as React from 'react';
export const archiveSvg = React.forwardRef(function archiveSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M12.313.5a2.25 2.25 0 0 1 1.8.9l.837 1.117a2.75 2.75 0 0 1 .55 1.65v9.083a2.25 2.25 0 0 1-2.25 2.25H2.75A2.25 2.25 0 0 1 .5 13.25V4.167c0-.595.193-1.174.55-1.65L1.888 1.4a2.25 2.25 0 0 1 1.8-.9h8.624ZM2 5.25v8c0 .414.336.75.75.75h10.5a.75.75 0 0 0 .75-.75v-8H2Zm6 1a.75.75 0 0 1 .75.75v3.19l.72-.72a.75.75 0 1 1 1.06 1.06l-2 2a.762.762 0 0 1-.244.162c-.032.014-.065.022-.098.03-.014.004-.026.01-.04.012-.005.002-.01.002-.016.003a.754.754 0 0 1-.265 0l-.016-.003c-.014-.002-.026-.008-.04-.011-.033-.009-.066-.017-.098-.03-.03-.013-.056-.029-.083-.045a.745.745 0 0 1-.16-.118l-2-2a.75.75 0 1 1 1.06-1.06l.72.72V7A.75.75 0 0 1 8 6.25ZM3.687 2a.75.75 0 0 0-.6.3L2.25 3.417a1.25 1.25 0 0 0-.178.333h11.856a1.25 1.25 0 0 0-.178-.333L12.912 2.3a.75.75 0 0 0-.6-.3H3.688Z',
    }),
  );
});
archiveSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var archive = {
  category: 'icon',
  colorable: true,
  name: 'archive',
  svg: archiveSvg,
};
